import { AGENT_IDS, DATA_CATALOG_API_TOOL_IDS } from '@/app/data-catalog/_common/constants'
import { useApiRequest } from '@/lib/http-utils'
import { useQuery } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'

export type Schema = {
  schema_name: string
  schema_domain: string
  schema_description: string
  schema_owners: string[]
  schema_version: number
  all_tables: any[]
}

export type SchemaAPIResponse = {
  service_name: string
  database_name: string
  database_source: string
  database_domain: string
  database_description: string
  database_owners: string[]
  database_version: number
  schemas: Schema[]
}

export type SchemaQueryParams = {
  service_name: string
  database_name: string
  assetType?: string
}

export function useSchemaQuery(params: SchemaQueryParams) {
  const agentId = AGENT_IDS.DATA_CATALOG_AGENT
  const { apiRequest, domainId } = useApiRequest()

  return useQuery<SchemaAPIResponse>({
    queryKey: ['schemas', params.service_name, params.database_name],
    queryFn: async () => {
      const basePath = taskManagerApiPaths.agentById({ domainId, agentId })

      const response = await apiRequest({
        path: basePath,
        queryParams: {
          tool_id: DATA_CATALOG_API_TOOL_IDS.FETCH_ALL_SCHEMAS,
        },
        options: {
          method: 'POST',
          body: JSON.stringify({
            catalogSelector: {
              service_name: params.service_name,
              database_name: params.database_name,
            },
          }),
        },
      })

      if (!response.ok) {
        throw new Error('Error fetching schema')
      }

      const json = (await response.json()) as { output: SchemaAPIResponse }
      return json.output
    },
  })
}
